export function object_has_property(maybe, property, predicate = undefined) {
    return (value_is_non_array_object(maybe)
        && property in maybe
        && (undefined === predicate
            || predicate(maybe[property])));
}
export function object_has_only_properties_that_match_predicate(maybe, predicate) {
    return (value_is_non_array_object(maybe)
        && Object.values(maybe).every(e => predicate(e)));
}
export function property_exists_on_object(object, property) {
    return property in object;
}
export function object_has_non_empty_array_property(maybe, property, predicate = undefined) {
    return (object_has_property(maybe, property)
        && is_non_empty_array(maybe[property], predicate));
}
export function object_has_property_that_equals(maybe, property, expects) {
    return object_has_property(maybe, property) && expects === maybe[property];
}
export function value_is_non_array_object(maybe) {
    return ('object' === typeof maybe
        && !(maybe instanceof Array)
        && null !== maybe);
}
export function is_non_empty_array(maybe, predicate = undefined) {
    return (maybe instanceof Array
        && maybe.length >= 1
        && (undefined === predicate || maybe.every((e) => predicate(e))));
}
export function object_only_has_that_property(maybe, property, predicate = undefined) {
    return (value_is_non_array_object(maybe)
        && object_has_property(maybe, property)
        && 1 === Object.keys(maybe).length
        && (undefined === predicate || predicate(maybe[property])));
}
export function annoyingly_have_to_escape_property(property) {
    return property.replace(/([[\]])/g, '\\$1');
}
export class SupportedSubSchemaType {
}
//# sourceMappingURL=CustomPairingTypes.js.map